import type { LucideIcon } from 'lucide-react';

interface EmptyStateAction {
  label: string;
  onClick?: () => void;
  href?: string;
}

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: React.ReactNode;
  action?: EmptyStateAction;
  className?: string;
}

export function EmptyState({ icon: Icon, title, description, action, className = '' }: EmptyStateProps) {
  return (
    <div className={`text-center py-12 text-gray-500 ${className}`}>
      <Icon className="h-12 w-12 mx-auto text-gray-300 mb-4" />
      <p className="text-lg">{title}</p>
      {description && (
        <p className="text-sm mt-2">{description}</p>
      )}
      {action && (
        action.href ? (
          <a
            href={action.href}
            className="inline-block mt-4 px-4 py-2 text-sm font-medium text-legacy-600 border border-legacy-600 rounded-md hover:bg-legacy-50 transition-colors"
          >
            {action.label}
          </a>
        ) : action.onClick ? (
          <button
            onClick={action.onClick}
            className="mt-4 px-4 py-2 text-sm font-medium text-legacy-600 border border-legacy-600 rounded-md hover:bg-legacy-50 transition-colors"
          >
            {action.label}
          </button>
        ) : null
      )}
    </div>
  );
}
